import { render } from "./RewardUpdateCaapExamResultModal.vue?vue&type=template&id=6fdb8152"
import script from "./RewardUpdateCaapExamResultModal.vue?vue&type=script&lang=js"
export * from "./RewardUpdateCaapExamResultModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__